import React, { Fragment, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { ReactTableDefaults } from 'react-table'
import get from 'lodash/get'
import uniq from 'lodash/uniq'
import classNames from 'classnames'

import TimeSlotForm from './TimeSlotForm'
import { DataTable } from 'components/DataTable'
import { ReactComponent as Add } from 'components/DataTable/add.svg'
import timeSlotColumns from './timeSlotColumns'
import styles from './ShopTimeSlot.module.scss'
import { StyledShopTimeSlot } from './styled'

const ShopTimeSlot = ({ ranges = [], onChange }) => {
	const [t] = useTranslation()
	const [selectedSlot, setSelectedSlot] = useState()
	const existingSlots = uniq(ranges.map(({ timeSlot, description }) => ({ timeSlot, description })))

	const TrComponent = ({ rowInfo = {}, ...props }) => {
		const { className } = props
		const isPivoted = rowInfo.subRows
		if(!isPivoted) {
			// Workaround to filter strange empty rows in the end
			const weirdRow = get(props, 'className', '')
			if(weirdRow.indexOf('-padRow') >= 0) {
				return null
			}
			return <ReactTableDefaults.TrComponent {...props} />
		}
		const cell = props.children[rowInfo.level]
		cell.props.style.maxWidth = 'none'
		cell.props.style.flexGrow = 1
		return(
			<div {...props} className={classNames(className, 'rt-tr')}>
				<Fragment>
					{cell}
					<div
						onClick={() => {
							const existingDays = get(rowInfo, 'subRows', []).map(({ day }) => day)
							const { description, timeSlot } = get(rowInfo, 'subRows[0]', {})
							setSelectedSlot({ timeSlot, description, existingDays })
						}}
						className={styles.add}
					>
						<Add />
					</div>
				</Fragment>
			</div>
		)
	}

	const handleMutateRow = mutateVals => {
		// 'mutateVals' is id if deleting and 'mutateVals' is an object of vals if editing
		const isDeleting = typeof mutateVals === 'string' || typeof mutateVals === 'number'
		if(isDeleting) {
			onChange([{ id: mutateVals }])
		} else {
			const { id, ...restVals } = mutateVals
			setSelectedSlot({ id, ...restVals })
		}
	}

	return(
		<StyledShopTimeSlot>
			<DataTable
				data={ranges}
				columns={timeSlotColumns(t)}
				groupBy={{
					columns: ['timeSlot']
				}}
				pivotBy={['description']}
				onAddRecord={() => setSelectedSlot({})}
				mutateRow={{
					onRowMutate: handleMutateRow,
					editBtn: true,
					colProps: { width: 70 }
				}}
				getTrProps={(state, rowInfo) => ({ rowInfo })}
				TrComponent={TrComponent}
				sortable={false}
				resizable={false}
				height={400}
				collapseOnDataChange={false}
			/>
			{selectedSlot &&
				<TimeSlotForm
					formData={selectedSlot}
					onSubmit={onChange}
					onClose={() => setSelectedSlot(null)}
					existingSlots={existingSlots}
				/>
			}
		</StyledShopTimeSlot>
	)
}

export default ShopTimeSlot
